import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

const GlobalStyles = () => {
  return (
    <MuiGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
          margin: 0,
          padding: 0,
        },
        html: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          height: '100%',
          width: '100%',
        },
        body: {
          backgroundColor: '#f4f6f8',
          height: '100%',
          width: '100%',
        },
        a: {
          textDecoration: 'none',
        },
        '#root': {
          height: '100%',
          width: '100%',
        },
        '.m-t-10': {
          marginTop: '10px !important',
        },

        // If you want to re-enable the loader later:
        /*
        '.loader': {
          border: '16px solid #f3f3f3',
          borderRadius: '50%',
          borderTop: '16px solid blue',
          borderRight: '16px solid green',
          borderBottom: '16px solid red',
          borderLeft: '16px solid pink',
          width: '120px',
          height: '120px',
          animation: 'spin 2s linear infinite',
        },
        '@keyframes spin': {
          '0%': {
            transform: 'rotate(0deg)',
          },
          '100%': {
            transform: 'rotate(360deg)',
          },
        },
        */
      }}
    />
  );
};

export default GlobalStyles;
